import { schema } from 'normalizr';

const secondHandBoardgame = new schema.Entity('boardgames');

export const secondHandBoardgames = new schema.Array(secondHandBoardgame);

export default secondHandBoardgame;
